import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { runtime } from '../../platform/runtime';
import { authStorage } from '../../platform/storage';
import { parseSessionTestLimit } from '../../platform/sessionTestLimit.mjs';

export default function SessionTestBanner() {
    const token = useSelector(state => state.auth.token);
    const [expiry, setExpiry] = useState(null);
    const [readFailed, setReadFailed] = useState(false);
    const mode = import.meta.env.MODE;
    const enabled = runtime.isNative() && ['mobile-development', 'mobile-staging'].includes(mode);
    const seconds = enabled ? parseSessionTestLimit(mode, import.meta.env.VITE_NATIVE_SESSION_TEST_SECONDS) : null;
    useEffect(() => {
        let cancelled = false;
        setExpiry(null);
        setReadFailed(false);
        if (seconds !== null && token) {
            authStorage.get('expiryTimestamp').then(value => {
                if (!cancelled) setExpiry(value);
            }).catch(() => { if (!cancelled) setReadFailed(true); });
        }
        return () => { cancelled = true; };
    }, [token, seconds]);
    if (seconds === null) return null;
    return <div role="status" style={{ background: '#ffdf00', color: '#171717', padding: '8px 12px', textAlign: 'center', fontSize: 12, lineHeight: 1.4 }}>
        <strong>DEV TEST — SESSION LIMIT: {seconds} SECONDS</strong>
        <div>Build: {import.meta.env.VITE_NATIVE_SESSION_TEST_BUILD_ID || 'unknown'}</div>
        <div>{!token ? 'Sign in to start the expiration test.'
            : readFailed ? 'Unable to read saved expiry.'
                : expiry ? `Saved session expires: ${new Date(Number(expiry)).toLocaleTimeString()}`
                    : 'Reading saved session expiry…'}</div>
    </div>;
}
